<template>
  <div class="mainPage">
    <div class="one" style="cursor: pointer">
      <img :src="imageList[0]" @dragstart.prevent @click="goTo('createMusic', '1')" alt="" />
    </div>
    <div class="two container" style="cursor: pointer">
      <img :src="imageList[1]" @dragstart.prevent @click="goTo('musicComposition', '2')" alt="" />
    </div>
    <div class="three container" style="cursor: pointer">
      <img :src="imageList[2]" @dragstart.prevent @click="goTo('bookComposition', '3')" alt="" />
    </div>
    <div class="four" style="cursor: pointer">
      <img :src="imageList[3]" @dragstart.prevent @click="goTo('plushing', '4')" alt="" />
    </div>
    <div class="five container" style="cursor: pointer">
      <img :src="imageList[4]" @dragstart.prevent @click="goTo('musicScore', '5')" alt="" />
    </div>
    <el-dialog
      title="绑定手机号"
      :visible.sync="bindPhoneVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
    >
      <div>
        <el-input placeholder="手机号" v-model="form.phone" id="no_border">
          <template slot="prepend"><i class="el-icon-phone"></i></template>
        </el-input>
      </div>
      <div class="codebox">
        <el-input
          v-model="form.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
        >
        </el-input>
        <div class="login-code">
          <img @dragstart.prevent :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </div>
      <div class="yzmBox">
        <el-button type="primary" :disabled="disabled" @click="getVerCode">{{
          buttonName
        }}</el-button>
        <div class="inputbox">
          <el-input
            v-model="form.phoneCode"
            placeholder="请输入验证码"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <!-- <el-button type="primary" @click="submit">确 定</el-button> -->
        <div class="submitBox" @click="submit">确定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import {setItem} from '@/utils/storage'
import { wechatWxPhone } from "@/api/memberCenter";
import { getMusicBannerReceptionListApi } from "@/api/index";
import { getCode, pusuhPhoneCode } from "@/api/regits";
import { getUserDeatils, qqbindPhone } from "@/api/login";
export default {
  data() {
    return {
      imageList: [], //首页图数据
      bindPhoneVisible: false,
      form: {
        phone: "",
        code: "",
        uuid: "",
        phoneCode: "",
      },
      codeUrl: "",
      count: 60,
      buttonName: "获取验证码",
      disabled: false,
      qqData: false,
    };
  },
  mounted() {
    //获取首页图数据
    getMusicBannerReceptionListApi()
      .then((res) => {
        res.rows.map((item) => {
          this.imageList.push(this.$image + item.picUrl);
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // 禁用右键菜单
    document.addEventListener('contextmenu', this.disableContextMenu);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    document.removeEventListener('contextmenu', this.disableContextMenu);
  },
  async created() {
    this.getCode();
    const url = window.location.href;

    // console.log(url.split("?")[1].split("=")[0],'666');
    // console.log('aaaaaaaaa');
    if (url.indexOf("?") > 0 && url.split("?").length > 1) {
      // console.log(url.split("?")[1].split("=")[0]);
      if (url.split("?")[1].split("=")[0] == "token") {
        //绑定
        await this.$store.commit("setToken", url.split("?")[1].split("=")[1]);
        setTimeout(()=>{
          window.location.href = 'https://cnzhipu.com/';
        })
        this.$message.success("登录成功");
      } else if (url.split("?")[1].split("=")[0] == "openid") {
        //扫码登录未绑定手机号
        this.$message("检测到您未绑定手机号,请先绑定手机号");
        console.log(url,'url');
        if (url.split("?")[1].split("=")[1].split("&")[1] == "invitation") {
          //wx新用户
          // console.log(url.split("?")[1].split("=")[1].split('&')[1],'新用户扫码之后的邀请key');
          this.$message("检测到您是邀请的新用户");
          this.form.openId = url.split("?")[1].split("=")[1].split("&")[0];
          this.form.invitation = url.split("?")[1].split("=")[2];
          // console.log('新用户的邀请码：'+url.split("?")[1].split("=")[2]);
        } else if (
          //qq新用户邀请进来的
          url.split("?")[1].split("=")[1].split("&")[1] == "invitationqq"
        ) {
          // console.log(url,'qq新用户邀请进来的')                                     
          this.qqData = true;
          this.form.openId = url.split("?")[1].split("=")[1].split("&")[0];
          this.form.invitation = url.split("?")[1].split("=")[2];
          // console.log(url,'url',this.form.invitation,'invation');
          //如果是用户点击qq登录，所以切换
        } else if (url.split("?")[1].split("=")[1].split("&")[1] == "qq") {
          this.form.openId = url.split("?")[1].split("=")[1].split("&")[0];
          this.qqData = true;
        } else {
          this.form.openId = url.split("?")[1].split("=")[1];
        }
        this.bindPhoneVisible = true;
        // if(url.split("?")[1].split("=")[0] == "openid")
      } else if (url.split("?")[1].split("=")[0] == "repeat") {
        this.$message.warning("已被其他手机号绑定");
      } else if (url.split("?")[1].split("=")[0] == "invitation") {
        // setItem('invite',url.split("?")[1].split("=")[1])
        localStorage.setItem("invite", url.split("?")[1].split("=")[1]);
        // console.log("刚进入首页的邀请码：" + url.split("?")[1].split("=")[1]);
      } else if (url.split("?")[1].split("=")[0] == "code") {
        let params = {
          code: url.split("?")[1].split("&")[0].split("=")[1],
        }; 
        if (localStorage.getItem("invite")) {
          params.state = localStorage.getItem("invite");
        } else {
          // params.state = url.split('?')[1].split('&')[1].split('=')[1]
          params.state = "STATE";
        }
        // console.log('尾号code,',params);
       
        // qqCodeCallback(params).then((res) => {
        //   if (res.code == 200) {
        //     window.location.href = res.msg;
        //   }
        //   localStorage.removeItem('invite')
        // });
      }
      // qqfirst({code:url.split('?')[1].split('&')[0].split('=')[1],state:url.split('?')[1].split('&')[1].split('=')[1]})
    }
  },
  methods: {
    disableContextMenu(event) {
      event.preventDefault(); // 阻止默认的右键菜单
    },
    goTo(path, argument) {
      this.$router.push({ path: path, query: { id: argument } });
      this.$nextTick(() => {
        window.scrollTo({
          top: 0, //回到底部
          behavior: "auto", //smooth 平滑；auto:瞬间
        });
      });
    },
    submit() {
      var reg = /^1[3456789]\d{9}$/;
      if (
        this.form.code == "" ||
        this.form.phoneCode == "" ||
        this.form.phone == ""
      ) {
        this.$message.warning("请填写完整内容");
        return;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      console.log(this.form,'提交的form');
      if (this.qqData) {
        qqbindPhone(this.form).then(async (res) => {
          if (res.code == 200) {
            this.$message.success("绑定成功");
            await this.$store.commit("setToken", res.msg);
            this.getUserinfo();
            this.bindPhoneVisible = false;
            if(localStorage.getItem('invite')){
              localStorage.removeItem('invite')
            }
          }
        });
      } else {
        wechatWxPhone(this.form).then(async (res) => {
          if (res.code == 200) {
            this.$message.success("绑定成功");
            await this.$store.commit("setToken", res.token);
            this.getUserinfo();
            this.bindPhoneVisible = false;
            if(localStorage.getItem('invite')){
              localStorage.removeItem('invite')
            }
          }
        });
      }
    },
    async getUserinfo() {
      try {
        const res = await getUserDeatils();
        if (res.code == 200) {
          this.$store.commit("setUserInfo", res.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    getCode() {
      getCode()
        .then((res) => {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.form.uuid = res.uuid;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //发送短信验证码
    getVerCode() {
      let reg = /^1[3456789]\d{9}$/;
      if (this.form.code == "" || this.form.phone == "") {
        this.$message.warning("请填写完整内容");
        return;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      let that = this;
      if (this.timeout) return this.$message("请勿重复点击");
      let params = {
        imageCode: that.form.code,
        phone: that.form.phone,
        uuid: that.form.uuid,
        openId: that.form.openId,
      };
      pusuhPhoneCode(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("发送成功");
            this.timeout = setInterval(() => {
              if (this.count < 1) {
                this.disabled = false;
                this.buttonName = "获取验证码";
                this.count = 59;
                clearInterval(this.timeout);
                this.timeout = null;
              } else {
                this.disabled = true;
                this.buttonName = this.count-- + "s后重发";
              }
            }, 1000);
          } else {
            this.$message.error("发送失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.el-dialog__wrapper {
  overflow: hidden !important;
}
.submitBox {
  cursor: pointer;
  margin: 0 auto;
  padding: 10px 0;
  width: 100%;
  background: #4a9ef8;
  border-radius: 6px;
}
.codebox {
  margin-top: 20px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  .login-code {
    height: 40px;
    width: 32%;
  }
}
.yzmBox {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .inputbox {
    width: 64%;
  }
}
// .mainPage > div {
//   height: 500px;
// }
.one {
  height: 600px !important;
}
.two {
  margin-top: 20px;
  height: 650px !important;
}
.three {
  margin-top: 20px;
  height: 650px !important;
}
.four {
  margin-top: 20px;
  height: 600px !important;
}
.five {
  height: 650px !important;
  margin-top: 20px;
  margin-bottom: 20px;
}
@media screen and (max-width: 1100px) {
  .one{
    height: 400px !important;
  }
  .two{
    height: 440px !important;
  }
  .three{
    height: 440px !important;
  }
  .four{
    height: 400px !important;
  }
  .five{
    height: 440px !important;
  }
}
.one,
.two,
.three,
.four,
.five {
  overflow: hidden;
  transition: all 0.5s;
  &:hover {
    transform: translateY(-4px);
    img {
      transition: all 0.5s;
      transform: scale(1.03);
    }
  }
}
</style>
